module.exports = __webpack_public_path__ + "img/ie.7b659f5a.svg";